import Router from 'next/router'

import { Button } from '@/components/ui/button'

import ArrowLeftIcon from '@/assets/icons/ic_logic-g-app_arrow-left.svg'
import { cn } from '@/utils/tw-helpers'
import { ComponentPropsWithoutRef } from 'react'

interface Props extends ComponentPropsWithoutRef<'button'> { }

export const BackButton = ({
  className,
  onClick = Router.back,
  ...rest
}: Props): JSX.Element => {
  return (
    <Button
      variant="outline"
      size="sm"
      className={cn(
        'absolute left-0 top-0 h-8 rounded-lg pl-0 text-[10px] leading-none md:h-10 md:w-[90px] md:rounded-xl md:text-[13px] lg:h-11',
        className
      )}
      onClick={onClick}
      {...rest}
    >
      <ArrowLeftIcon width={24} height={24} className="mr w-5 md:w-6" />
      戻る
    </Button>
  )
}
